import { Checkbox, TableCell, TableRow } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

interface IncludedFeedPlateProps {
  runIndex: number;
  plateIndex: number;
  plateWorklistInfo: {
    selected: boolean;
    activeWellCount: number;
    plateBarcode: string;
    plateID: number;
    selectedWells: any[];
    aspirateVol: number;
    dispenseVol: number;
    aspirateLC: string;
    dispenseLC: string;
  };
  updateIncludedPlateSelection: (runIndex: number, plateIndex: number) => void;
  updatePlateWorklistInfo: (
    key: string,
    value: string,
    runIndex: number,
    plateIndex: number
  ) => void;
  setPlateMapOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedPlate: Dispatch<SetStateAction<any>>;
}

export const IncludedFeedPlate = ({
  runIndex,
  plateIndex,
  plateWorklistInfo,
  updateIncludedPlateSelection,
  updatePlateWorklistInfo,
  setPlateMapOpen,
  setSelectedPlate,
}: IncludedFeedPlateProps) => {
  const handlePlateActiveWellClick = () => {
    setSelectedPlate({
      plateID: plateWorklistInfo.plateID,
      plateBarcode: plateWorklistInfo.plateBarcode,
      selectedWells: plateWorklistInfo.selectedWells,
    });
    setPlateMapOpen(true);
  };

  return (
    <TableRow>
      <TableCell>
        <Checkbox
          checked={plateWorklistInfo.selected}
          onChange={(e) => updateIncludedPlateSelection(runIndex, plateIndex)}
        />
      </TableCell>
      <TableCell>{plateWorklistInfo.plateBarcode}</TableCell>
      <TableCell
        onClick={() => handlePlateActiveWellClick()}
        style={{ cursor: "pointer" }}
      >
        {plateWorklistInfo.activeWellCount}
      </TableCell>
      <TableCell>
        <input
          style={{ width: "85px" }}
          value={plateWorklistInfo.aspirateVol}
          onChange={(e) =>
            updatePlateWorklistInfo(
              "aspirateVol",
              e.target.value,
              runIndex,
              plateIndex
            )
          }
        />
      </TableCell>
      <TableCell>
        <input
          style={{ width: "85px" }}
          value={plateWorklistInfo.dispenseVol}
          onChange={(e) =>
            updatePlateWorklistInfo(
              "dispenseVol",
              e.target.value,
              runIndex,
              plateIndex
            )
          }
        />
      </TableCell>
      <TableCell>
        <input value={plateWorklistInfo.aspirateLC} />
      </TableCell>
      <TableCell>
        <input disabled value={plateWorklistInfo.dispenseLC} />
      </TableCell>
    </TableRow>
  );
};
